import { useContext } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import MenuContext from "context/MenuContext";
import { getDomainCountryCode } from "redux/selectors/config";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { dispensaryHref } from "utils/dispensaryUrls";

import IconSvg from "components/IconSvg";
import IconTile from "components/IconTile";

const StrainCarousel: React.FC<{ className?: string }> = ({ className }) => {
  const { slug: dispensarySlug, retailType } =
    useSelector(getCurrentDispensary);
  const countryCode = useSelector(getDomainCountryCode);

  const {
    selectors: { menuFilters },
  } = useContext(MenuContext);

  const strainTypes = menuFilters
    ?.find((option) => option.name === "strain_category")
    ?.values?.map((value) => value.value);

  if (!strainTypes || !strainTypes.length) {
    return null;
  }

  const strainTypeList = ["Indica", "Sativa", "Hybrid"]
    .filter((type) => strainTypes.includes(type))
    .map((type) => ({
      link: dispensaryHref({
        additionalPath: `/menu?strain_category=${type}`,
        countryCode,
        retailType,
        slug: dispensarySlug,
      }),
      name: type,
    }));

  return (
    <div data-testid="strain-carousel" className={classnames(className)}>
      <h2 className="mb-lg" data-testid="strain-carousel-header">
        Shop by strain type
      </h2>
      <div className="row">
        {strainTypeList.map(({ link, name }) => (
          <div key={name} className="col-1/3">
            <IconTile
              title={name}
              link={link}
              eventCategory="Dispensary Menu Strain Type Shortcut"
              key={name}
            >
              <IconSvg
                width="40"
                height="40"
                filePath={`phenotypes/${name.toLowerCase()}.svg`}
              />
            </IconTile>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrainCarousel;
